import {header} from '../../data';
import Navbar from '../Navbar/Navbar';
import React from 'react';
import './Header.css';

const Header = () => {
  const {homepage, title} = header;
  //fake depoyment
  return (
    <header className="header center">
      <h3>
        {homepage ? (
          <a href={homepage} className="link">
            {title}
          </a>
        ) : (
          title
        )}
      </h3>
      <Navbar />
    </header>
  );
};

export default Header;
